<template>
  <div class="newPatient-container">
    <div class="container">
      <el-card class="main-container">
        <div class="main-header">
          <div class="main-header-left">
            <span>{{$t('Patient Profile')}}</span>
          </div>
        </div>
        <hr class="small-hr">
        <div class="content">
          <p>{{$t('uername')}}:<span>{{profile.username}}</span></p>
          <p style="float: left;">{{$t('alias')}}: </p><input  v-model="alias"   class="alias" maxlength="15">
          <p v-show="isA">Patient ID:<span style="margin-left: 36px;">0000001</span></p>
        </div>
        <hr class="small-hr">
        <div class="content content1"  :class="{'sw1':isSw}">
          <p>{{$t('Portrait')}}:</p>  <img :src="portrait">
          <p>{{$t('fullName')}}: <span style="margin-left: 20px;">{{profile.realname}}</span></p>
          <p v-show="isM" style="margin-left: 105px;cursor: pointer" @click="Remark = true">Remark: <span>Jack</span></p>
        </div>
        <div class="content content1">
          <p class="text">{{$t('gender')}}: <span style="margin-left: 25px;">{{profile.gender}}</span></p>
          <p class="text">{{$t('height')}}<span>{{profile.height}}</span></p>
          <p class="text">{{$t('weight')}}<span>{{profile.weight}}</span></p>
          <p>{{$t('birthday')}}:<span>{{profile.birthday}}</span></p>
        </div>
        <hr class="small-hr">
        <div class="content content1 content2" :class="{'sw2':isSw}">
          <p class="text2">{{$t('disType')}}:<span style="margin-left: 25px;">{{profile.diabetes_type}}</span></p>
          <p>{{$t('disDate')}}:<span>{{profile.date}}</span></p>
        </div>
        <hr class="small-hr">
        <div class="content content3">
          <p>{{$t('Address')}}:<span>{{profile.address}}</span></p>
          <p>{{$t('Postcode')}}: <span>{{profile.zipcode}}</span></p>
          <p>{{$t('Mobile')}}:<span>{{profile.mobile}}</span></p>
          <p>{{$t('Telephone')}}: <span style="margin-left: 15px;">{{profile.telephone}}</span></p>
          <p>{{$t('Email')}}:<span>{{profile.email}}</span></p>
        </div>
        <hr class="small-hr">

        <div class="footer">
          <div class="item1">
            <span  :class="{'es1':isEs||isDe||isPo||isCz}">{{$t('Inpatient')}}</span>
            <select v-model="profile.inHospital">
              <option>{{$t('Yes')}}</option><option>{{$t('No')}}</option>
            </select>
          </div>
          <div class="item1"><span :class="{'po1':isPo||isCz}">{{$t('Pno')}}</span><input v-model="profile.patientNo" ></div>
          <div class="item1 spe-item1"><span :class="{'po1':isPo||isCz}">{{$t('Bno')}}</span><input v-model="profile.bedNo" ></div>
        </div>
        <div class="operate">
          <button class="cancel" @click="back">{{$t('Cancel')}}</button>
          <button class="create" @click="create">{{$t('save')}}</button>
        </div>
      </el-card>
    </div>
    <!--remark对话框-->
    <el-dialog  :visible.sync="Remark" size="tiny" id="remark-form" :show-close="false" >
      <div slot="title" class="patientList-dialog-title">
        <span>Set remark</span>
        <img src="../../assets/cancel.png" @click="cancel">
      </div>
      <div slot class="dialog-body">
        <p>Please input remark in the following box</p>
        <input>
      </div>

      <div slot="footer" class="patientList-dialog-footer">
        <button  class="confirmButton" >Confirm</button>
        <button  class="cancelButton" @click="cancel">Cancel</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import auth from '../../auth/auth'
  export default{
    data(){
      return{
        inpatient:'', patient_no:'', bed_no:'',alias:'',isSw:false,isCz:false,
        isA:false, profile:'',Remark:false,isM:false,isEs:'',isDe:false,isPo:false,
      }
    },
    computed:{
      portrait(){
          return '/api/v2.0/person/'+parseInt(sessionStorage.getItem('patientId'))+'/portrait'
      }
    },
    methods:{
      back(){
        this.$router.push('/monitor')
      },
      cancel(){
        this.Remark = false;
      },
      create(){
        let info = {
          //realname: sessionStorage.getItem('patientName'),
          alias:this.alias,
          inHospital:this.profile.inHospital,
          patientNo:this.profile.patientNo,
          bedNo:this.profile.bedNo,
        };
        let Pid = parseInt(sessionStorage.getItem('patientId'));
        auth.modifyPatientProfile(this,Pid,info);
      },
    },
    mounted(){
      let Pid = parseInt(sessionStorage.getItem('patientId'));
      auth.getPatientProfile2(this,Pid);
      let lang = sessionStorage.getItem('language');
      this.isEs= (lang==='es')?true:false;
      this.isDe= (lang==='de')?true:false;
      this.isPo= (lang==='po')?true:false;
      this.isSw= (lang==='sw')?true:false;
      this.isCz= (lang==='cz')?true:false;
    },
  }
</script>
<style scoped>
  .newPatient-container{
    height:100%;
    width:100%;
    background-color:#fff;
  }
  .container{
    width:100%;
    margin:0 auto;
    background:#fafbfc;
    padding-top: 15px;
  }
  .main-container{
    width:97%;
    height:753px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
  }
  .main-header{
    width: 98%;
    margin:0 auto;
    height:20px;
    margin-bottom: 15px;
  }
  .main-header-left{
    float: left;
    height:20px;
    line-height: 20px;
    border-left: 2px solid #005dac;
  }
  .main-header-left span{
    margin-left:10px;
  }
  .small-hr{
    background:#e6e8ea;
    width:98%;
    height:1px;
    margin:0 auto 15px;
    border:none;
  }

  .content{
    width: 96%;
    margin:0 auto;
  }
  .content p{
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    margin-bottom: 20px;
    letter-spacing:-0.39px;
  }
  .content span{
    color:#0082d2;
    margin-left: 30px;
    letter-spacing:-0.29px;
  }
  .content1{
    height: 25px;
    margin-top: 30px;
    clear: both;
  }
  .content1 p{
    float: left;
  }
  .content1 img{
    background:#c9c9c9;
    border-radius:100px;
    width:51px;
    height:50px;
    float: left;
    margin:-15px 130px 0 50px;
  }
  .sw1 img{
    margin:-15px 105px 0 50px;
  }
  .content1 .text{
    margin-right: 145px;
  }
  .content1 span{
    margin-left: 20px;
  }
  .content2{
    margin-top: 20px;
  }
  .content2 .text2{
    margin-right: 90px;
  }
  .sw2 .text2{
    margin-right: 70px;
  }
  .alias{
    background:#ffffff;
    border:1px solid #d2d2d2;
    float: left;
    border-radius:4px;
    width:200px;
    height:30px;
    margin-left: 50px;
    padding-left: 10px;
    color:#0082d2;
    font-family:SFUIText-Regular;
    font-size: 16px;
    margin-top: -4px;
  }

  .footer{
    width:96%;
    margin:0 auto;
    margin-bottom: 60px;
  }
  .item1{
    float: left;
    width:30%;
    margin-right: 4%;
  }
  .item1 select,.item1 input{
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width:45%;
    height:35px;
    margin-left: 20%;
    padding-left: 6px;
    color:#282828;
    font-family:SFUIText-Regular;
    font-size: 16px;
  }
  .item1 input{
    width:50%;
    margin-left: 5%;
    padding-left: 8px;
  }
  .spe-item1{
    margin-right: 0;
  }
  .es1{
    width:50px;
    float: left;
  }
  .po1{
    width:90px;
    float: left;
  }


  .operate{
    width: 50%;
    float: right;
    margin-top:50px;
    margin-bottom: 20px;
    margin-right: 10px;
  }
  .operate button{
    background: transparent;
    border:1px solid #a3a3a3;
    border-radius:100px;
    width:150px;
    height:30px;
    outline: none;
    cursor: pointer;
    float: right;
  }
  .operate .create{
    margin-right: 20px;
  }

  /*对话框*/
  #remark-form{
    font-family:SFUIText-Regular;
  }
  .patientList-dialog-title{
    float: left;
    background-image:linear-gradient(-90deg, #38bcf7 0%, #3fa1f4 100%);
    height:45px;
    line-height: 50px;
    width:100%;
    margin:-20px 30px 0 -20px;
    font-size:18px;
    color:#ffffff;
    letter-spacing:-0.43px;
    position: absolute;
  }
  .patientList-dialog-title span{
    margin-left: 42px;
  }
  .patientList-dialog-title img{
    float: right;
    margin-top:16px;
    cursor: pointer;
    margin-right: 10px;
  }
  .dialog-body{
    width:90%;
    text-align:left;
    margin:30px 0 10px 20px;
  }
  .dialog-body p{
    margin-bottom: 21px;
    letter-spacing:-0.39px;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
  }
  .dialog-body input{
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width:100%;
    height:35px;
    font-size:20px;
    padding-left: 5px;
  }
  .patientList-dialog-footer {
    width: 90%;
    margin-left: -10px;
    margin-bottom: 10px;
  }
  .patientList-dialog-footer button{
    background: transparent;
    border:1px solid #a3a3a3;
    border-radius:100px;
    width:150px;
    height:30px;
    outline: none;
    cursor: pointer;
  }
  .patientList-dialog-footer .confirmButton{
    margin-left: 0;
    width:32%
  }
  .patientList-dialog-footer .cancelButton{
    margin-left: 15%;
    width:32%
  }


</style>



// WEBPACK FOOTER //
// patientProfile-noEdit.vue?7697a224